export default __webpack_public_path__ + "static/media/sign-up-img-2.e0e192b6.png";